function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent, Fragment } from "react";
import classnames from "classnames";
import colors from "styles/colors";
import ColorfulTitleComponent from "/components/core/colorful-title/colorful-title-component";
import { StyledParagraphComponent, StyledBody, StyledBottomLink } from "./paragraph-component.scss";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import PictureWithLinkComponent from "/components/core/picture-with-link/picture-with-link-component";
import { withSegmentsData } from "contexts/segment-context";
import { withGenericConfig } from "/contexts/generic-config-context";
import replace from "lodash/replace";
class ParagraphComponent extends PureComponent {
    renderBottomLink() {
        const { text, href } = this.props.bottomLink;
        const { textColor } = this.props;
        return /*#__PURE__*/ _jsx(StyledBottomLink, {
            className: "bottom-link-wrapper",
            children: /*#__PURE__*/ _jsx("a", {
                href: href,
                style: {
                    color: colors[textColor]
                },
                children: text
            })
        });
    }
    renderSignup() {
        const { signupForm, isFirstSegment } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: "signup-form-with-decorations-wrapper",
            children: /*#__PURE__*/ _jsx(SignupFormComponent, _object_spread({
                emailInputOpened: !!isFirstSegment
            }, signupForm))
        });
    }
    getTitle() {
        const { title, hasFreeTier } = this.props;
        return hasFreeTier ? replace(title, "Start your 14-day free trial", "") : title;
    }
    render() {
        const { image, topic, title, body, textDirection, bottomLink, titleFontSize, showSignup, isFirstSegment } = this.props;
        return /*#__PURE__*/ _jsxs(StyledParagraphComponent, {
            className: classnames("paragraph-component", {
                [textDirection]: textDirection
            }),
            children: [
                topic.text && /*#__PURE__*/ _jsx("div", {
                    className: "topic",
                    style: {
                        color: colors[topic.color]
                    },
                    children: topic.text
                }),
                title && /*#__PURE__*/ _jsxs("div", {
                    className: "title",
                    children: [
                        image && image.src && /*#__PURE__*/ _jsx(PictureWithLinkComponent, _object_spread({
                            className: "title-image"
                        }, image)),
                        /*#__PURE__*/ _jsx(ColorfulTitleComponent, {
                            text: this.getTitle(),
                            fontSize: titleFontSize,
                            isH1Heading: isFirstSegment
                        })
                    ]
                }),
                body.length > 0 && this.renderBody(),
                bottomLink.href && this.renderBottomLink(),
                showSignup && this.renderSignup()
            ]
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "renderInnerBody", ()=>{
            const { body } = this.props;
            return /*#__PURE__*/ _jsx(Fragment, {
                children: body.map((paragraph, index)=>/*#__PURE__*/ _jsx("span", {
                        className: "inner-body",
                        dangerouslySetInnerHTML: {
                            __html: paragraph
                        }
                    }, index))
            });
        });
        _define_property(this, "renderBody", ()=>{
            return /*#__PURE__*/ _jsxs(StyledBody, {
                className: "body",
                children: [
                    " ",
                    this.renderInnerBody(),
                    " "
                ]
            });
        });
    }
}
export default withSegmentsData(withGenericConfig(ParagraphComponent));
ParagraphComponent.defaultProps = {
    topic: {},
    title: "",
    body: [],
    bottomLink: {},
    showSignup: false
};
